module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', {
    staticClass: "header-h1"
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_title')))]), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_during_in_days')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_number_of_trainings')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_price')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_type_trainings')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_equipment')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_buy_membership')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedPayments), function(payment) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_mp_name')
      }
    }, [_vm._v(_vm._s(payment.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_mp_during_in_days')
      }
    }, [_vm._v(_vm._s(payment.durationInDays))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_number_of_trainings')
      }
    }, [_vm._v(_vm._s(payment.trainingNumber))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_mp_price')
      }
    }, [_vm._v(_vm._s(payment.price))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_payment_type_trainings')
      }
    }, [_vm._v(_vm._s(payment.trainingTypes))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_equipment')
      }
    }, [_vm._v(_vm._s((payment.additionalKit === null || payment.additionalKit.length === 0 ? '/' : payment.additionalKit)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_buy_membership')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.buyMemberShip(payment)
        }
      }
    }, [_c('i', {
      staticClass: "ti-shopping-cart"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_buy_membership')) + "\n                            ")])])])
  }), 0)])])])]), _vm._v(" "), _c('choose-date-for-membership-modal', {
    attrs: {
      "show": _vm.showDateForMembership,
      "package": _vm.paymentToBuy
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a46685ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Membership/BuyMembershipPackages.vue
// module id = 838
// module chunks = 0